// This is a separate set of shared functions to populate the DataLayer
// from state and push events & pageviews to GTM
import store from "../redux/store";

// Main Send GTM Event Function
const sendEvent = (eventName, data = false) => {
  try {
    const state = store.getState();

    const eventData = getStandardEventData(eventName, state);

    switch (eventName) {
      case "portalReferralsPage":
        eventData.user = getUserData(data);
        sendPageview("/referrals", "Customer Portal: Referrals");
        break;

      default:
      // No Default Action
    }

    window.dataLayer = getDataLayer();
    window.dataLayer.push(eventData);
  } catch (e) {
    console.error(eventName + " Tracking Event Failed To Process: " + e);
  }
};

// Faux Pageview Call
const sendPageview = (pageURL, pageTitle) => {
  window.dataLayer = getDataLayer();
  window.dataLayer.push({
    event: "portalPageview",
    page: {
      url: pageURL,
      title: pageTitle,
    },
  });
};

// General DL Call
const getDataLayer = () => {
  return window.dataLayer || [];
};

// Unique Event ID (If We Decide To Go CAPI Route)
const generateEventId = () => {
  return "GRIND" + Math.floor(Math.random() * Date.now()).toString();
};

// Standard Data For All Requests
const getStandardEventData = (eventName, state) => {
  const eventId = generateEventId();

  return {
    event: eventName,
    eventId,
  }

  // return {
  //   event: eventName,
  //   eventId: eventId,
  //   value: Number(state.checkout.cart.total_price.amount),
  //   cartToken: state.checkout.cart.token,
  //   cartItemCount: cart_item_count,
  //   ecommerce: getEcommLayer(eventName, state),
  //   ga4items: getGA4Products(state.checkout.cart),
  //   fbItems: getFBProducts(state.checkout.cart),
  //   subscription: getSubscriptionItems(state.checkout.cart),
  // };
};

// User Info
const getUserData = (user) => {
  return {
    email: user.email,
    firstName: user.first_name,
    lastName: user.last_name,
  };
};

export { sendEvent, sendPageview };
